import { jsx as o } from "react/jsx-runtime";
import "react";
import { ImageCard as E } from "../../../ImageCard/ImageCard.js";
import { AirDateFormatter as H } from "../../../AirDateFormatter/AirDateFormatter.js";
import { GetAirdateWrapper as J } from "../../../GetAirdateWrapper/GetAirdateWrapper.js";
import { Concat as _ } from "../../../Concat/Concat.js";
import { classes as K } from "../../../../utils/helpers.js";
import '../../../../assets/ShowSlide.css';const L = {
  "show-slide": "_show-slide_mt0c3_1"
}, Q = (t, l) => t ? l.preventDetailPage ? {
  href: "",
  type: "unknown",
  relatedResourceType: "unknown"
} : l.programType === "film" ? {
  href: `movie/${l.slug}`,
  type: "internal-link",
  relatedResourceType: "film"
} : {
  href: `show/${l.slug}`,
  type: "internal-link",
  relatedResourceType: "series"
} : l.seriesPrefix ? {
  href: "",
  type: "show-modal",
  relatedSourceId: l.seriesPrefix,
  relatedResourceType: "series"
} : l.titleCode ? {
  href: "",
  type: "show-modal",
  relatedResourceId: l.titleCode,
  relatedResourceType: "film"
} : {
  href: "",
  type: "unknown",
  relatedResourceId: "",
  relatedResourceType: "unknown"
};
function ot({
  series: t,
  nextAirdate: l = null,
  titlePosition: U = "left",
  titleColor: D = "#fff",
  fullSizeImagePosition: S = [50, 50],
  mobileImagePosition: M = [50, 50],
  lazyLoad: O = !0,
  fetchPriority: j = null,
  decoding: z = "async",
  hasSeriesPages: a = !0,
  handleClicks: A = () => !0,
  altText: n = "",
  SCHEDULE_ENDPOINT: F = "",
  NETWORK: G = ""
}) {
  var p, d, u, c, r, g, f, e, h, y, i, w, I, C, b, T, R, v, k, $, x, P;
  const N = {
    url: ((d = (p = t == null ? void 0 : t.images) == null ? void 0 : p.slide) == null ? void 0 : d.url) ?? ((c = (u = t == null ? void 0 : t.bannerImage) == null ? void 0 : u.image) == null ? void 0 : c.publicUrl),
    altText: n,
    aspectRatio: 2.011764705882353,
    sources: ((g = (r = t == null ? void 0 : t.images) == null ? void 0 : r.slide) == null ? void 0 : g.url) ?? ((e = (f = t == null ? void 0 : t.bannerImage) == null ? void 0 : f.image) == null ? void 0 : e.sources)
  }, W = (y = (h = t == null ? void 0 : t.bannerMobileImage) == null ? void 0 : h.image) != null && y.publicUrl ? {
    url: (w = (i = t == null ? void 0 : t.bannerMobileImage) == null ? void 0 : i.image) == null ? void 0 : w.publicUrl,
    altText: n,
    aspectRatio: 388 / 594
  } : {
    url: ""
  }, m = (C = (I = t.logoImage) == null ? void 0 : I.image) != null && C.publicUrl ? `<div class="show-slide__logo-wrapper show-slide--display"><img src="${(v = (R = (T = (b = t.logoImage) == null ? void 0 : b.image) == null ? void 0 : T.sizes) == null ? void 0 : R[0].srcSets) == null ? void 0 : v[0].src}" alt="${t.title}"/></div><h1 class="display-none">${t.title}</h1>` : `<h1>${t.title}</h1>`, q = l === null ? /* @__PURE__ */ o(
    _,
    {
      list: [
        m,
        /* @__PURE__ */ o(
          J,
          {
            programId: (t == null ? void 0 : t.seriesPrefix) ?? (t == null ? void 0 : t.titleCode),
            programType: t != null && t.titleCode ? "film" : "series",
            separatorType: "pipe",
            SCHEDULE_ENDPOINT: F,
            NETWORK: G
          }
        )
      ]
    }
  ) : /* @__PURE__ */ o(_, { list: [m, /* @__PURE__ */ o(H, { airdateStr: l, separatorType: "pipe" })] }), B = Q(a, t);
  return /* @__PURE__ */ o(
    "div",
    {
      className: K([L["show-slide"], "show-slide"]),
      style: {
        "--show-slide-logo-ratio": (($ = (k = t.logoImage) == null ? void 0 : k.image) == null ? void 0 : $.width) / ((P = (x = t.logoImage) == null ? void 0 : x.image) == null ? void 0 : P.height)
      },
      children: /* @__PURE__ */ o(
        E,
        {
          image: N,
          mobileImage: W,
          fullSizeImagePosition: S,
          mobileImagePosition: M,
          lazyLoad: O,
          fetchPriority: j,
          decoding: z,
          overlayContent: q,
          overlayPosition: U,
          overlayTextColor: D,
          fullCardClickable: !(t != null && t.preventDetailPage),
          cta: B,
          handleClicks: a ? () => !0 : A,
          relatedResourceId: a ? "" : (t == null ? void 0 : t.programType) === "film" ? t == null ? void 0 : t.titleCode : t == null ? void 0 : t.seriesPrefix
        }
      )
    }
  );
}
export {
  ot as ShowSlide,
  ot as default
};
